<template>
  <div class="container-fluid py-4">
    <!-- Navigation Tabs -->
    <div class="row align-items-center">
      <div class="col-lg-12 col-sm-12">
        <div class="nav-wrapper position-relative end-0">
          <ul class="nav nav-pills nav-fill p-2" role="tablist">
            <li class="nav-item">
              <a
                @click="changeTab(1)"
                href="#"
                class="nav-link mb-0 px-0 py-2"
                :class="{ active: type === 1 }"
                data-bs-toggle="tab"
                role="tab"
                :aria-selected="type === 1"
              >
                Basic Information
              </a>
            </li>
            <li class="nav-item">
              <a
                @click="changeTab(2)"
                href="#"
                class="nav-link mb-0 px-0 py-2"
                :class="{ active: type === 2 }"
                data-bs-toggle="tab"
                role="tab"
                :aria-selected="type === 2"
              >
                Physical Branches
              </a>
            </li>
            <li class="nav-item">
              <a
                @click="changeTab(3)"
                href="#"
                class="nav-link mb-0 px-0 py-2"
                :class="{ active: type === 3 }"
                data-bs-toggle="tab"
                role="tab"
                :aria-selected="type === 3"
              >
                Stripe Rates
              </a>
            </li>
            <li class="nav-item">
              <a
                @click="changeTab(4)"
                href="#"
                class="nav-link mb-0 px-0 py-2"
                :class="{ active: type === 4 }"
                data-bs-toggle="tab"
                role="tab"
                :aria-selected="type === 4"
              >
                Stripe Readers
              </a>
            </li>
            <li class="nav-item">
              <a
                @click="changeTab(5)"
                href="#"
                class="nav-link mb-0 px-0 py-2"
                :class="{ active: type === 5 }"
                data-bs-toggle="tab"
                role="tab"
                :aria-selected="type === 5"
              >
                Login Account
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Tab 1: Basic Information -->
    <div class="row mt-4" v-if="type === 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row my-3" style="align-items: center">
              <div class="col-lg-6 col-12 font-weight-bold text-danger">
                Created: {{ form.created_at_format }}
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Status</label>
              </div>
              <div class="col-lg-4 col-12" style="display: inline-flex">
                <MaterialRadio v-model="form.status" value="1">
                  Active
                </MaterialRadio>
                <MaterialRadio v-model="form.status" value="0">
                  Deactive
                </MaterialRadio>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Merchant Code <i class="required">*</i></label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="merchant_code"
                    placeholder="Merchant Code"
                    type="text"
                    class="form-control"
                    v-model="form.merchant_code"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Merchant Name <i class="required">*</i></label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="merchant_name"
                    placeholder="Merchant Name"
                    type="text"
                    class="form-control"
                    v-model="form.brand_name"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Parent Company</label>
              </div>
              <div class="col-lg-4 col-12">
                <select
                  id="parent_merchant_id"
                  class="form-select p-2"
                  v-model="form.parent_merchant_id"
                >
                  <option selected value="0">Select parent company</option>
                  <option
                    v-for="merchant in dataListAllMerchant"
                    :key="merchant.id"
                    :value="merchant.id"
                  >
                    {{ merchant.brand_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Company Email <i class="required">*</i></label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="company_email"
                    placeholder="Company Email"
                    type="email"
                    class="form-control"
                    v-model="form.company_email"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Finance Email</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="finance_email"
                    placeholder="Finance Email"
                    type="email"
                    class="form-control"
                    v-model="form.finance_email"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Finance Mobile</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="finance_mobile"
                    placeholder="Finance Mobile"
                    type="text"
                    class="form-control"
                    v-model="form.finance_mobile"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Stripe Connected Account</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="stripe_connected_account"
                    placeholder="Stripe Connected Account"
                    type="text"
                    class="form-control"
                    v-model="connected_account"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Stripe URL</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="stripe_url"
                    placeholder="Stripe URL"
                    type="text"
                    class="form-control"
                    v-model="form.pos_stripe_url"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Stripe Api Key</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="stripe_api_key"
                    placeholder="Stripe Api Key"
                    type="text"
                    class="form-control"
                    v-model="form.pos_stripe_api_key"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Stripe Session Timeout</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="stripe_session_timeout"
                    placeholder="Stripe Session Timeout"
                    type="text"
                    class="form-control"
                    v-model="form.pos_stripe_session_timeout"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Stripe Paynow Session Timeout</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="pos_stripe_paynow_session_timeout"
                    placeholder="Stripe Paynow Session Timeout"
                    type="text"
                    class="form-control"
                    v-model="form.pos_stripe_paynow_session_timeout"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Refund Fee</label>
              </div>
              <div class="col-lg-4 col-12">
                <div class="input-group input-group-outline null">
                  <input
                    id="refund_fee"
                    placeholder="Refund Fee"
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control"
                    v-model="form.refund_fee"
                  />
                </div>
              </div>
            </div>

            <div class="row my-3" style="align-items: center">
              <div class="col-lg-3 col-12">
                <label class="form-label">Logo</label>
              </div>
              <div class="col-lg-4 col-12">
                <input
                  style="display: none"
                  type="file"
                  id="image1"
                  @change="handleFileUpload"
                  accept="image/*"
                  ref="fileInput"
                />
                <material-button
                  @click="uploadFile"
                  class="btn-sm bg-gradient-success"
                >
                  Upload
                </material-button>
              </div>
            </div>

            <div
              id="preview"
              class="ps-2"
              style="position: relative; width: fit-content"
              v-if="urlImagePreview"
            >
              <img :src="urlImagePreview" alt="Merchant Logo" />
              <i
                class="fa fa-times icon-close-sidenav-main danger"
                style="
                  position: absolute;
                  top: -8px;
                  right: -6px;
                  color: #f44335;
                  font-size: 20px;
                  cursor: pointer;
                "
                aria-hidden="true"
                @click="clearImage"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 2: Physical Branches -->
    <div class="row mt-4" v-if="type === 2">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Add Branch Modal -->
            <div
              class="modal fade"
              id="addBranch"
              tabindex="-1"
              role="dialog"
              aria-labelledby="addBranchLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <div class="card card-plain">
                      <div class="card-header pb-0 text-left">
                        <h5 class="">Add New Physical Branch</h5>
                      </div>
                      <div class="card-body pb-3">
                        <div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label">ID</label>
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              {{ new_branch_id }}
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label"
                                >Code <span class="text-danger">*</span></label
                              >
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter physical branch code"
                                  type="text"
                                  class="form-control"
                                  v-model="physicalBranch.code"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label"
                                >Name <span class="text-danger">*</span></label
                              >
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter physical branch name"
                                  type="text"
                                  class="form-control"
                                  v-model="physicalBranch.name"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label">Address</label>
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter physical branch address"
                                  type="text"
                                  class="form-control"
                                  v-model="physicalBranch.address"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label"
                                >Stock Control Page Passcode</label
                              >
                            </div>
                            <div class="col-lg-10 col-sm-10 d-flex">
                              <MaterialRadio
                                id="stock_passcode_on_create"
                                name="stock_passcode_enabled_create"
                                v-model="physicalBranch.stock_passcode_enabled"
                                value="1"
                              >
                                On
                              </MaterialRadio>
                              <MaterialRadio
                                id="stock_passcode_off_create"
                                name="stock_passcode_enabled_create"
                                v-model="physicalBranch.stock_passcode_enabled"
                                value="0"
                              >
                                Off
                              </MaterialRadio>
                            </div>
                          </div>
                          <div
                            class="row my-3"
                            v-if="physicalBranch.stock_passcode_enabled === '1'"
                          >
                            <div class="col-lg-3 col-12">
                              <label class="form-label"
                                >Passcode
                                <span class="text-danger">*</span></label
                              >
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter 4 character passcode"
                                  type="text"
                                  maxlength="4"
                                  class="form-control"
                                  v-model="physicalBranch.stock_passcode"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-12">
                              <label class="form-label">Status</label>
                            </div>
                            <div class="col-lg-10 col-sm-10 d-flex">
                              <MaterialRadio
                                v-model="physicalBranch.status"
                                value="1"
                              >
                                Active
                              </MaterialRadio>
                              <MaterialRadio
                                v-model="physicalBranch.status"
                                value="0"
                              >
                                Deactive
                              </MaterialRadio>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <div class="row w-60">
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn btn-cancel btn-close-modal-create-branch"
                          data-bs-dismiss="modal"
                          variant="gradient"
                          color="danger"
                          fullWidth
                        >
                          Cancel
                        </material-button>
                      </div>
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn"
                          variant="gradient"
                          @click="createBranch"
                          color="success"
                          fullWidth
                        >
                          Create
                        </material-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Assign Code to Branch Modal -->
            <div
              class="modal fade"
              id="assignCodeToBranch"
              tabindex="-1"
              role="dialog"
              aria-labelledby="assignCodeLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <div class="card card-plain">
                      <div class="card-header pb-0 text-left">
                        <h5 class="">Assign Code To Branch</h5>
                      </div>
                      <div class="card-body pb-3">
                        <form>
                          <div class="row my-3">
                            <div class="col-lg-3 col-sm-3">
                              <label class="form-label">Code</label>
                            </div>
                            <div class="col-lg-9 col-sm-9">
                              <select
                                id="code_id"
                                class="form-select p-2"
                                v-model="code_id"
                              >
                                <option
                                  v-for="code in dataListCode"
                                  :key="code.id"
                                  :value="code.id"
                                >
                                  {{ code.code }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-sm-3">
                              <label class="form-label">Code Name</label>
                            </div>
                            <div class="col-lg-9 col-sm-9">
                              {{ getCodeName }}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <div class="row w-60">
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn btn-close-code-assign-to-branch btn-cancel"
                          data-bs-dismiss="modal"
                          variant="gradient"
                          color="danger"
                          fullWidth
                        >
                          Cancel
                        </material-button>
                      </div>
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn"
                          variant="gradient"
                          color="success"
                          fullWidth
                          @click="assignCodeToBranch"
                        >
                          Save
                        </material-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-start mt-3">
              <div class="row align-items-center">
                <div class="col-lg-9 col-sm-9"></div>
                <div class="col-lg-3 col-sm-3">
                  <material-button
                    data-bs-toggle="modal"
                    data-bs-target="#addBranch"
                    class="btn btn-primary toast-btn"
                    variant="gradient"
                    color="success"
                    fullWidth
                    @click="clearDataAddBranch"
                  >
                    ADD PHYSICAL BRANCH
                  </material-button>
                </div>
              </div>
            </div>

            <div class="text-start mt-3">
              <div class="row align-items-center">
                <div class="col-lg-9 col-sm-9">
                  <div class="input-group input-group-outline null">
                    <input
                      id="search"
                      type="text"
                      placeholder="Search here"
                      class="form-control"
                      v-model="textSearchBranch"
                      @keyup.enter="getList(1)"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-3">
                  <material-button
                    @click="getList(1)"
                    class="btn btn-primary toast-btn"
                    variant="gradient"
                    color="success"
                    fullWidth
                  >
                    SEARCH
                  </material-button>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0 mt-3">
              <thead>
                <tr>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    ID
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Branch Name
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Status
                  </th>
                   <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Created Date
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody v-if="dataListBranchsByMerchant.length">
                <template
                  v-for="branch in dataListBranchsByMerchant"
                  :key="branch.id"
                >
                  <tr
                    :style="
                      showDivBoxBranch === branch.id
                        ? 'background: lightgray;'
                        : ''
                    "
                  >
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ branch.id_text }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ branch.name }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        :class="[
                          branch.status == 1 ? 'bg-success' : 'bg-secondary',
                          'badge badge-sm',
                        ]"
                      >
                        {{ branch.status ? "Active" : "Deactive" }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ branch.created_at_format }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="showBoxBranch(branch)"
                      >
                        <i
                          class="fas fa-pencil-alt text-dark me-2"
                          aria-hidden="true"
                        ></i>
                        Edit
                      </a>
                      <a
                        class="btn btn-link text-danger text-gradient px-3 mb-0"
                        data-bs-toggle="modal"
                        data-bs-target="#deleteBranchModal"
                        href="javascript:;"
                        @click="confirmDeleteBranch(branch.id)"
                      >
                        <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                        Delete
                      </a>
                    </td>
                  </tr>

                  <!-- Edit Branch Form -->
                  <tr
                    v-if="showDivBoxBranch && showDivBoxBranch === branch.id"
                    class="physical-branch-form"
                  >
                    <td colspan="5">
                      <div class="branch-edit-container">
                        <div class="row">
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0"
                                  >Code <span class="text-danger">*</span></label
                                >
                              </div>
                              <div
                                class="input-group input-group-outline"
                                style="max-width: 500px"
                              >
                                <input
                                  placeholder="Enter physical branch code"
                                  v-model="physicalBranch.code"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0"
                                  >Name <span class="text-danger">*</span></label
                                >
                              </div>
                              <div
                                class="input-group input-group-outline"
                                style="max-width: 500px"
                              >
                                <input
                                  placeholder="Enter physical branch name"
                                  v-model="physicalBranch.name"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0"
                                  >Stock Control Page Passcode</label
                                >
                              </div>
                              <div
                                class="input-group input-group-outline d-flex mt-1"
                                style="max-width: 500px"
                              >
                                <MaterialRadio
                                  class="ps-0"
                                  id="stock_passcode_on_edit"
                                  name="stock_passcode_enabled_edit"
                                  v-model="physicalBranch.stock_passcode_enabled"
                                  value="1"
                                >
                                  On
                                </MaterialRadio>
                                <MaterialRadio
                                  id="stock_passcode_off_edit"
                                  name="stock_passcode_enabled_edit"
                                  v-model="physicalBranch.stock_passcode_enabled"
                                  value="0"
                                >
                                  Off
                                </MaterialRadio>
                              </div>
                            </div>
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                              v-if="physicalBranch.stock_passcode_enabled === '1'"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0"
                                  >Passcode
                                  <span class="text-danger">*</span></label
                                >
                              </div>
                              <div
                                class="input-group input-group-outline"
                                style="max-width: 500px"
                              >
                                <input
                                  placeholder="Enter 4 character passcode"
                                  type="text"
                                  maxlength="4"
                                  class="form-control"
                                  v-model="physicalBranch.stock_passcode"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0">Status</label>
                              </div>
                              <div
                                class="input-group input-group-outline d-flex mt-1"
                                style="max-width: 500px"
                              >
                                <MaterialRadio
                                  class="ps-0"
                                  v-model="physicalBranch.status"
                                  value="1"
                                >
                                  Active
                                </MaterialRadio>
                                <MaterialRadio
                                  v-model="physicalBranch.status"
                                  value="0"
                                >
                                  Deactive
                                </MaterialRadio>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0">Address</label>
                              </div>
                              <div
                                class="input-group input-group-outline"
                                style="max-width: 500px"
                              >
                                <input
                                  placeholder="Enter physical branch address"
                                  v-model="physicalBranch.address"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-12 d-flex justify-content-start align-items-center">
                            <div class="pe-3">
                                <label class="form-label mb-0"></label>
                              </div>
                            <div class="pe-3 ms-1">
                              <input
                                id="physical_branch_hide_under_outlet_list"
                                type="checkbox"
                                v-model="physicalBranch.is_hide_outlet_list"
                              />
                              <label
                                for="physical_branch_hide_under_outlet_list"
                                class="form-label mb-0 ms-2"
                              >
                                Hide under outlet list
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-12">
                            <div
                              class="d-flex justify-content-center align-items-center my-3"
                            >
                              <div class="pe-3">
                                <label class="form-label mb-0">Stripe Connected Account</label>
                              </div>
                              <div
                                class="input-group input-group-outline"
                                style="max-width: 500px"
                              >
                                <input
                                  id="physical_branch_stripe_connected_account"
                                  placeholder="Physical Branch Stripe Connected Account"
                                  type="text"
                                  class="form-control"
                                  v-model="physicalBranch.stripe_user_id"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-center">
                          <material-button
                            class="btn btn-primary toast-btn"
                            variant="gradient"
                            color="success"
                            @click="createBranch"
                          >
                            Save
                          </material-button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" class="text-center">No item available</td>
                </tr>
              </tbody>
            </table>

            <pagination
              v-if="pagination.last_page > 1"
              :pagination="pagination"
              :current_page="pagination.current_page"
              :last_page="pagination.last_page"
              @page-changed="getList"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 3: Stripe Rates -->
    <div class="row mt-4" v-if="type === 3">
      <div class="col-12">
        <div class="card">
          <div class="card-body" style="overflow-x: auto">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  ></th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Visa(%)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Visa Const($)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Master(%)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Master Const($)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    AMEX(%)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    AMEX Const($)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Paynow(%)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Paynow Const($)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Other(%)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Other($)
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <!-- Online Payment Row -->
                <tr>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">Online Payment</p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[0].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[0].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[0].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[0].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[1].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[1].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[1].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[1].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[2].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[2].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[2].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[2].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[3].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[3].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[3].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[3].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[4].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[4].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 1"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[4].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[4].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div v-if="row_number === 1">
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="updateStripeRates"
                      >
                        Update
                      </a>
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="cancelStripeRates"
                      >
                        Cancel
                      </a>
                    </div>
                    <a
                      v-else
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editInlineRow(1)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i>
                      Edit
                    </a>
                  </td>
                </tr>

                <!-- Via Stripe Reader Payment Row -->
                <tr>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">
                      Via Stripe Reader Payment
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[5].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[5].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[5].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[5].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[6].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[6].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[6].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[6].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[7].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[7].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[7].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[7].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[8].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[8].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[8].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[8].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[9].percentage"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[9].percentage
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div
                      class="input-group input-group-outline null"
                      v-if="row_number === 2"
                    >
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter"
                        v-model="dataStripeRates[9].fixed_amount"
                      />
                    </div>
                    <p v-else class="text-xs text-secondary mb-0">
                      {{
                        dataStripeRates &&
                        dataStripeRates.length > 0 &&
                        dataStripeRates[9].fixed_amount
                      }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <div v-if="row_number === 2">
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="updateStripeRates"
                      >
                        Update
                      </a>
                      <a
                        class="btn btn-link text-dark px-3 mb-0"
                        href="javascript:;"
                        @click="cancelStripeRates"
                      >
                        Cancel
                      </a>
                    </div>
                    <a
                      v-else
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editInlineRow(2)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i>
                      Edit
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 4: Stripe Readers -->
    <div class="row mt-4" v-if="type === 4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Add Reader Modal -->
            <div
              class="modal fade"
              id="addReader"
              tabindex="-1"
              role="dialog"
              aria-labelledby="addReaderLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <div class="card card-plain">
                      <div class="card-header pb-0 text-left">
                        <h5 class="" v-if="reader_id">Update Reader</h5>
                        <h5 class="" v-else>Add New Reader</h5>
                      </div>
                      <div class="card-body pb-3">
                        <div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-sm-3">
                              <label class="form-label">Reader Id</label>
                            </div>
                            <div class="col-lg-9 col-sm-9">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter Reader Id"
                                  type="text"
                                  class="form-control"
                                  v-model="reader_number_id"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-sm-3">
                              <label class="form-label">CODE</label>
                            </div>
                            <div class="col-lg-9 col-sm-9">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter Reader Code"
                                  type="text"
                                  class="form-control"
                                  v-model="reader_code"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-3 col-sm-3">
                              <label class="form-label"
                                >Statement <br />
                                Descriptor</label
                              >
                            </div>
                            <div class="col-lg-9 col-sm-9">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter Statement Descriptor"
                                  type="text"
                                  class="form-control"
                                  v-model="reader_statement"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <div class="row w-60">
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn btn-cancel btn-close-modal-create-reader"
                          data-bs-dismiss="modal"
                          variant="gradient"
                          color="danger"
                          fullWidth
                        >
                          Cancel
                        </material-button>
                      </div>
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn"
                          variant="gradient"
                          @click="createReader"
                          color="success"
                          fullWidth
                        >
                          Save
                        </material-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Branch
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Code Name
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Code
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Account
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Date Created
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  ></th>
                </tr>
              </thead>
              <tbody v-if="dataListCodeByBranch.length">
                <template
                  v-for="code in dataListCodeByBranch"
                  :key="code.id"
                >
                  <tr>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ code.branch_name }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ code.name }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ code.code }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">acct_1234</p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <p class="text-xs text-secondary mb-0">
                        {{ code.created_at_format }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <material-button
                        @click="showBoxStripeReaders(code)"
                        class="btn-sm bg-gradient-success"
                      >
                        Edit
                      </material-button>
                    </td>
                  </tr>
                  <tr v-if="showDivBoxStripeReaders === code.id">
                    <td colspan="6" style="padding: 0px">
                      <div class="stripe-reader-container">
                        <div
                          style="
                            align-items: center;
                            display: inline-flex;
                            justify-content: space-between;
                            width: 100%;
                            margin-top: 20px;
                          "
                        >
                          <div style="width: 130px">
                            <label
                              class="form-label"
                              style="
                                font-weight: bold;
                                text-decoration: underline;
                              "
                            >
                              Reader
                            </label>
                          </div>
                          <material-button
                            data-bs-toggle="modal"
                            data-bs-target="#addReader"
                            @click="resetCreateReader('add')"
                            class="btn-sm bg-gradient-success btn-create-reader"
                          >
                            Add Reader
                          </material-button>
                          <material-button
                            style="display: none"
                            data-bs-toggle="modal"
                            data-bs-target="#addReader"
                            class="btn-sm bg-gradient-success btn-update-reader"
                          >
                            Update Reader
                          </material-button>
                        </div>

                        <table class="table align-items-center mb-0">
                          <thead>
                            <tr>
                              <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                              >
                                ID
                              </th>
                              <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                              >
                                Code
                              </th>
                              <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                              >
                                Reader Id
                              </th>
                              <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                              >
                                Statement Descriptor
                              </th>
                              <th
                                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                              ></th>
                            </tr>
                          </thead>
                          <tbody v-if="dataListReaderByCode.length">
                            <tr
                              v-for="(reader, index) in dataListReaderByCode"
                              :key="reader.id"
                            >
                              <td class="align-middle text-center text-sm">
                                <p class="text-xs font-weight-bold mb-0">
                                  {{ index + 1 }}
                                </p>
                              </td>
                              <td class="align-middle text-center text-sm">
                                <p class="text-xs text-secondary mb-0">
                                  {{ reader.code }}
                                </p>
                              </td>
                              <td class="align-middle text-center text-sm">
                                <p class="text-xs text-secondary mb-0">
                                  {{ reader.number }}
                                </p>
                              </td>
                              <td class="align-middle text-center text-sm">
                                <p class="text-xs text-secondary mb-0">
                                  {{ reader.statement }}
                                </p>
                              </td>
                              <td class="align-middle text-center text-sm">
                                <material-button
                                  @click="showPopupEditReader(reader)"
                                  class="btn-sm bg-gradient-success"
                                >
                                  Edit
                                </material-button>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="5" class="text-center">
                                No item available
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No item available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab 5: Login Account -->
    <div class="row mt-4" v-if="type === 5">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div
              class="row my-3"
              style="align-items: center; margin-bottom: 50px"
            >
              <div class="col-lg-3 col-sm-3">
                <label class="form-label"
                  >2FA Verification required when login</label
                >
              </div>
              <div class="col-lg-3 col-sm-3" style="display: inline-flex">
                <MaterialRadio v-model="form.is_enable_2fa_login" value="1">
                  Enable
                </MaterialRadio>
                <MaterialRadio v-model="form.is_enable_2fa_login" value="0">
                  Disable
                </MaterialRadio>
              </div>
              <div class="col-lg-4 col-12" style="display: inline-flex">
                <material-button
                  @click="saveAll"
                  class="btn bg-gradient-success btn-md"
                >
                  Save
                </material-button>
              </div>
            </div>

            <div
              style="
                display: inline-flex;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 20px;
              "
            >
              <div>
                <p class="text-md font-weight-bold mb-0">Login Accounts</p>
              </div>
              <div>
                <material-button
                  @click="resetCreateMerchantUserAccount"
                  data-bs-toggle="modal"
                  data-bs-target="#addAccountMerchantModal"
                  class="btn-sm bg-gradient-success"
                  style="margin-right: 10px"
                >
                  Add Account
                </material-button>
                <material-button
                  @click="downloadLoginUsers"
                  class="btn-sm bg-gradient-success"
                >
                  Export List
                </material-button>
              </div>
            </div>

            <!-- Add/Edit Account Modal -->
            <div
              class="modal fade"
              id="addAccountMerchantModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="addAccountLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <div class="card card-plain">
                      <div class="card-header pb-0 text-left">
                        <h5 class="" v-if="formUser.id === 0">ADD ACCOUNT</h5>
                        <h5 class="" v-if="formUser.id > 0">UPDATE ACCOUNT</h5>
                      </div>
                      <div class="card-body pb-3">
                        <form @submit.prevent="createMerchantUserAccount">
                          <div class="row my-3">
                            <div class="col-lg-4 col-12">
                              <label class="form-label"
                                >Email Address <i class="required">*</i></label
                              >
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter Email"
                                  type="text"
                                  class="form-control"
                                  v-model="formUser.email"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-4 col-12">
                              <label class="form-label"
                                >First Name <i class="required">*</i></label
                              >
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter First Name"
                                  type="text"
                                  class="form-control"
                                  v-model="formUser.first_name"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-4 col-12">
                              <label class="form-label"
                                >Last Name <i class="required">*</i></label
                              >
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div class="input-group input-group-outline null">
                                <input
                                  placeholder="Enter Last Name"
                                  type="text"
                                  class="form-control"
                                  v-model="formUser.last_name"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-lg-4 col-12">
                              <label v-if="formUser.id > 0" class="form-label"
                                >New Password</label
                              >
                              <label v-else class="form-label"
                                >Password <i class="required">*</i></label
                              >
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div
                                class="input-group input-group-outline null i-password"
                              >
                                <input
                                  placeholder="Enter Password"
                                  :type="
                                    formUser.showPassword ? 'text' : 'password'
                                  "
                                  class="form-control"
                                  v-model="formUser.password"
                                />
                                <i
                                  class="material-icons-round opacity-10 fs-5"
                                  @click="togglePasswordVisibility"
                                >
                                  {{
                                    formUser.showPassword
                                      ? "visibility_off"
                                      : "visibility"
                                  }}
                                </i>
                              </div>
                            </div>
                          </div>
                          <div class="row my-3" v-if="formUser.id > 0">
                            <div class="col-lg-4 col-12">
                              <label class="form-label">Status</label>
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div class="input-group input-group-outline null">
                                <a
                                  v-if="formUser.status === 1"
                                  @click="updateStatusUserAccount"
                                  style="
                                    text-decoration: underline;
                                    cursor: pointer;
                                  "
                                  class="text-danger"
                                >
                                  Deactive
                                </a>
                                <a
                                  v-if="formUser.status === 0"
                                  @click="updateStatusUserAccount"
                                  style="
                                    text-decoration: underline;
                                    cursor: pointer;
                                  "
                                  class="text-success"
                                >
                                  Active
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="row my-3" v-if="formUser.id > 0">
                            <div class="col-lg-4 col-12">
                              <label class="form-label">Last Login</label>
                            </div>
                            <div class="col-lg-8 col-sm-8">
                              <div class="input-group input-group-outline null">
                                <p>{{ formUser.last_login_at_formated }}</p>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <div class="row w-60">
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          class="btn toast-btn btn-close-modal-create-merchant-account btn-cancel"
                          data-bs-dismiss="modal"
                          variant="gradient"
                          color="danger"
                          fullWidth
                        >
                          Cancel
                        </material-button>
                      </div>
                      <div class="col-lg-6 col-sm-6 my-1">
                        <material-button
                          v-if="formUser.id === 0"
                          class="btn toast-btn"
                          variant="gradient"
                          color="success"
                          fullWidth
                          @click="createMerchantUserAccount"
                        >
                          Create
                        </material-button>
                        <material-button
                          v-if="formUser.id > 0"
                          class="btn toast-btn"
                          variant="gradient"
                          color="success"
                          fullWidth
                          @click="createMerchantUserAccount"
                        >
                          Update
                        </material-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    First Name
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Last Name
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Email
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Created Date
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Status
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody v-if="dataListUserAccountByMerchant.length">
                <tr
                  v-for="user in dataListUserAccountByMerchant"
                  :key="user.id"
                >
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">
                      {{ user.first_name }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">
                      {{ user.last_name }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">
                      {{ user.email }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">
                      {{ user.created_at_formated }}
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <p class="text-xs text-secondary mb-0">
                      <span
                        :class="[
                          user.status == 1 ? 'bg-success' : 'bg-secondary',
                          'badge badge-sm',
                        ]"
                      >
                        {{ user.status ? "Active" : "Deactive" }}
                      </span>
                    </p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <material-button
                      @click="resetPasswordUserAccount(user.id)"
                      class="btn-sm bg-gradient-success"
                      style="margin-right: 10px"
                    >
                      Reset Password
                    </material-button>
                    <material-button
                      @click="editMerchantUserAccount(user)"
                      class="btn-sm bg-gradient-success"
                      data-bs-toggle="modal"
                      data-bs-target="#addAccountMerchantModal"
                    >
                      Edit
                    </material-button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No item available</td>
                </tr>
              </tbody>
            </table>

            <pagination
              v-if="pagination.last_page > 1"
              :pagination="pagination"
              :current_page="pagination.current_page"
              :last_page="pagination.last_page"
              @page-changed="getList"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Save Button for Basic Info -->
    <div class="row align-items-center" v-if="type === 1">
      <div
        class="col-lg-12 col-sm-12"
        style="display: flex; justify-content: center"
      >
        <material-button
          @click="saveAll"
          class="btn mb-0 bg-gradient-success btn-md null my-4 mb-2"
        >
          Save
        </material-button>
      </div>
    </div>

    <!-- Delete Branch Modal -->
    <div
      class="modal fade"
      id="deleteBranchModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteBranchLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-normal" id="deleteBranchLabel">
              Are you sure you want to delete this branch?
            </h5>
            <button
              type="button"
              class="btn-close text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <material-button
              class="btn bg-gradient-secondary"
              data-bs-dismiss="modal"
            >
              No
            </material-button>
            <material-button
              class="btn bg-gradient-primary"
              @click="handleDeleteBranch"
              data-bs-dismiss="modal"
            >
              Yes
            </material-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Code Assigned Modal -->
    <div
      class="modal fade"
      id="deleteCodeAssignedToBranchModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteCodeLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-normal" id="deleteCodeLabel">
              Are you sure you want to delete this code?
            </h5>
            <button
              type="button"
              class="btn-close text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <material-button
              class="btn bg-gradient-secondary"
              data-bs-dismiss="modal"
            >
              No
            </material-button>
            <material-button
              class="btn bg-gradient-primary"
              @click="deleteCodeAssigned"
              data-bs-dismiss="modal"
            >
              Yes
            </material-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Download Form -->
    <form
      :action="`${actionDownload}/admin/download-login-account`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="$route.params.id" />
      <input type="hidden" name="action_export" value="download" />
      <input id="downloadFormLoginUsers" type="submit" class="d-none" />
    </form>

    <!-- Notification Snackbar -->
    <div
      class="position-fixed top-1 end-1 message-success"
      style="z-index: 9999"
    >
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>

    <!-- Loading Component -->
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import MaterialButton from "@/components/MaterialButton.vue";
import $ from "jquery";
import MerchantService from "../../services/merchant.service";
import Pagination from "@/components/Pagination.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";

const INITIAL_FORM_STATE = {
  id: 0,
  merchant_code: "",
  brand_name: "",
  logo: null,
  parent_company: "",
  company_email: "",
  finance_email: "",
  finance_mobile: "",
  pos_stripe_url: "",
  pos_stripe_api_key: "",
  pos_stripe_session_timeout: "",
  pos_stripe_paynow_session_timeout: "",
  refund_fee: 0,
  status: null,
  parent_merchant_id: 0,
  is_enable_2fa_login: 0,
};

const INITIAL_BRANCH_STATE = {
  id: 0,
  code: "",
  name: "",
  address: "",
  // "1" turns the stock control page passcode on, "0" leaves that page open.
  stock_passcode_enabled: "0",
  stock_passcode: "",
  status: "0",
  stripe_user_id: "",
  is_hide_outlet_list: 0,
};

const INITIAL_USER_STATE = {
  id: 0,
  email: "",
  first_name: "",
  last_name: "",
  phone_number: 0,
  password: "",
  last_login_at_formated: "",
  status: null,
  showPassword: false,
};

export default {
  name: "MerchantDetail",
  components: {
    MaterialButton,
    Pagination,
    MaterialSnackbar,
    MaterialRadio,
    MaterialLoading,
  },
  data() {
    return {
      type: 1,
      urlImagePreview: null,
      showDivBox: false,
      showDivBoxBranch: false,
      form: { ...INITIAL_FORM_STATE },
      physicalBranch: { ...INITIAL_BRANCH_STATE },
      dataStripeRates: [],
      row_number: 0,
      dataListBranchsByMerchant: [],
      pagination: {},
      page: 1,
      textSearchBranch: "",
      new_branch_id: "",
      idToUpdateBranch: 0,
      idToDeleteBranch: 0,
      message: "",
      snackbar: null,
      loaderActive: false,
      dataListCode: [],
      code_id: 0,
      textSearchListCodeByBranch: "",
      dataListCodeByBranch: [],
      idToDeleteCodeAssignedToBranch: 0,
      showDivBoxStripeReaders: 0,
      connected_account: "",
      reader_id: "",
      reader_code: "",
      reader_number_id: "",
      reader_statement: "",
      dataListReaderByCode: [],
      dataListAllMerchant: [],
      dataListUserAccountByMerchant: [],
      formUser: { ...INITIAL_USER_STATE },
      action_export_login_user: "list",
      actionDownload: process.env.VUE_APP_BASE_URL,
      minty_assign_code_to_branch_id: 0,
    };
  },
  computed: {
    getCodeName() {
      const code = this.dataListCode.find((entry) => entry.id === this.code_id);
      return code ? code.name : "";
    },
  },
  mounted() {
    setNavPills();
    this.getParentCompany();
    this.getDetail();
  },
  methods: {
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    showSuccessMessage(msg) {
      this.snackbar = "success";
      this.message = msg;
      this.setTimeOutNotification();
    },
    showErrorMessage(msg) {
      this.snackbar = "danger";
      this.message = msg;
      this.setTimeOutNotification();
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    closeSnackbar() {
      this.snackbar = null;
    },

    async changeTab(type) {
      this.type = type;
      this.page = 1;
      this.pagination = {};

      switch (type) {
        case 2: // Physical Branches
          this.dataListBranchsByMerchant = [];
          this.dataListUserAccountByMerchant = [];
          await this.getList(this.page);
          await this.getListCode();
          break;
        case 3: // Stripe Rates
          await this.getStripeRates();
          break;
        case 4: // Stripe Readers
          this.showDivBoxStripeReaders = 0;
          await this.getListCodeByBranch(true);
          break;
        case 5: // Login Account
          this.dataListBranchsByMerchant = [];
          this.dataListUserAccountByMerchant = [];
          await this.getList(this.page);
          break;
      }
    },

    togglePasswordVisibility() {
      this.formUser.showPassword = !this.formUser.showPassword;
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        this.form.logo = null;
        this.urlImagePreview = null;
        return;
      }

      const validTypes = ["image/png", "image/jpg", "image/jpeg", "image/svg"];
      if (!validTypes.includes(file.type)) {
        this.showErrorMessage("File must be an image (PNG, JPG, JPEG, or SVG)");
        return;
      }

      this.form.logo = file;
      this.urlImagePreview = URL.createObjectURL(this.form.logo);
    },

    uploadFile() {
      this.$refs.fileInput.click();
    },

    clearImage() {
      this.form.logo = null;
      this.urlImagePreview = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    showBoxBranch(branch) {
      this.showDivBoxBranch = branch.id;
      this.idToUpdateBranch = branch.id;
      this.physicalBranch = {
        name: branch.name,
        code: branch.code,
        address: branch.address,
        stock_passcode_enabled: branch.stock_passcode ? "1" : "0",
        stock_passcode: branch.stock_passcode,
        status: branch.status.toString(),
        stripe_user_id: branch.stripe_user_id,
        is_hide_outlet_list: branch.is_hide_outlet_list === 1,
      };
    },

    async getDetail() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const response = await MerchantService.getDetailMerchant(merchantId);
        const data = response.data.data;

        this.form = {
          id: data.id,
          merchant_code: data.merchant_code,
          brand_name: data.brand_name,
          parent_company: data.parent_company,
          parent_merchant_id: data.parent_merchant_id,
          company_email: data.company_email || "",
          finance_email: data.finance_email || "",
          finance_mobile: data.finance_mobile || "",
          pos_stripe_url: data.pos_stripe_url,
          pos_stripe_api_key: data.pos_stripe_api_key,
          pos_stripe_session_timeout: data.pos_stripe_session_timeout,
          pos_stripe_paynow_session_timeout:
            data.pos_stripe_paynow_session_timeout,
          refund_fee: data.refund_fee != null ? data.refund_fee : 0,
          status: data.status ? data.status.toString() : "0",
          is_enable_2fa_login: data.is_enable_2fa_login === 0 ? "0" : "1",
          created_at_format: data.created_at_format,
        };

        this.urlImagePreview = data.logo;
        this.connected_account = data.connected_account;
      } catch (error) {
        console.error("Error fetching merchant details:", error);
        this.showErrorMessage("Failed to load merchant details");
      } finally {
        this.hideLoader();
      }
    },

    async saveAll() {
      if (this.type !== 1 && this.type !== 5) return;

      this.showLoader();
      try {
        await MerchantService.updateMerchant(this.form);
        await this.getDetail();
        this.showSuccessMessage("Save successfully!");
      } catch (error) {
        console.error("Error saving merchant:", error);
        this.showErrorMessage(error.response.data.result.message || "Failed to save");
      } finally {
        this.hideLoader();
      }
    },

    async getStripeRates() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const response = await MerchantService.getStripeRates({ merchantId });
        this.dataStripeRates = response.data.data;
        this.row_number = 0;
      } catch (error) {
        console.error("Error fetching stripe rates:", error);
        this.showErrorMessage("Failed to load stripe rates");
      } finally {
        this.hideLoader();
      }
    },

    async editInlineRow(row_number) {
      const merchantId = this.$route.params.id;

      try {
        const response = await MerchantService.getStripeRates({ merchantId });
        this.dataStripeRates = response.data.data;
        this.row_number = row_number;
      } catch (error) {
        console.error("Error fetching stripe rates:", error);
        this.showErrorMessage("Failed to load stripe rates");
      }
    },

    cancelStripeRates() {
      this.getStripeRates();
    },

    async updateStripeRates() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const dataForm = {
          merchantId,
          data: this.dataStripeRates,
        };

        await MerchantService.updateStripeRates(dataForm);
        await this.getStripeRates();
        this.row_number = 0;
        this.showSuccessMessage("Save successfully!");
      } catch (error) {
        console.error("Error updating stripe rates:", error);
        this.showErrorMessage(error.message || "Failed to update");
      } finally {
        this.hideLoader();
      }
    },

    async getList(page) {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        if (this.type === 2) {
          const response = await MerchantService.listBranchsByMechant({
            merchantId,
            page,
            search_keyword: this.textSearchBranch,
          });
          this.dataListBranchsByMerchant = response.data.data.items;
          this.pagination = response.data.data;
          this.page = this.pagination.current_page;
          this.new_branch_id = response.data.data.max_id;
        } else if (this.type === 5) {
          const response = await MerchantService.listUserAccountByMechant({
            merchantId,
            page,
            action_export: this.action_export_login_user,
          });
          this.dataListUserAccountByMerchant = response.data.data.items;
          this.pagination = response.data.data;
          this.page = this.pagination.current_page;
        }
      } catch (error) {
        console.error("Error fetching list:", error);
        this.showErrorMessage("Failed to load data");
      } finally {
        this.hideLoader();
      }
    },

    async createBranch() {
      if (!this.physicalBranch.name) {
        this.showErrorMessage("Please enter physical branch name");
        return;
      }

      const passcodeEnabled = this.physicalBranch.stock_passcode_enabled === "1";
      const stockPasscode = (this.physicalBranch.stock_passcode || "").trim();

      if (passcodeEnabled && stockPasscode.length !== 4) {
        this.showErrorMessage(
          "Stock control page passcode must be 4 characters"
        );
        return;
      }

      const merchantId = this.$route.params.id;
      const dataForm = {
        merchantId,
        name: this.physicalBranch.name,
        code: this.physicalBranch.code,
        address: this.physicalBranch.address,
        // Off clears the stored passcode, which is what leaves the stock
        // control page open for that branch.
        stock_passcode: passcodeEnabled ? stockPasscode : "",
        status: this.physicalBranch.status,
        is_hide_outlet_list: this.physicalBranch.is_hide_outlet_list ? 1 : 0,
      };

      if (this.idToUpdateBranch > 0) {
        dataForm.id = this.idToUpdateBranch;
      }

      this.showLoader();
      try {
        const response = await MerchantService.createBranch(dataForm);

        if (response.data.result.isSuccess) {
          await this.getList(this.page);
          $(".btn-close-modal-create-branch").click();
          this.showSuccessMessage("Save successfully!");
        } else {
          this.showErrorMessage(response.data.result.message);
        }
      } catch (error) {
        console.error("Error creating branch:", error);
        this.showErrorMessage(error.message || "Failed to save branch");
      } finally {
        this.hideLoader();
      }
    },

    confirmDeleteBranch(id) {
      this.idToDeleteBranch = id;
    },

    async handleDeleteBranch() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        await MerchantService.deleteBranch({
          merchantId,
          id: this.idToDeleteBranch,
        });

        await this.getList(this.page);
        this.idToDeleteBranch = 0;
        this.showSuccessMessage("Delete successfully!");
      } catch (error) {
        console.error("Error deleting branch:", error);
        this.showErrorMessage("Failed to delete branch");
      } finally {
        this.hideLoader();
      }
    },

    clearDataAddBranch() {
      this.showDivBoxBranch = false;
      this.idToUpdateBranch = 0;
      this.physicalBranch = { ...INITIAL_BRANCH_STATE };
    },

    async getListCode() {
      try {
        const response = await MerchantService.listCode();
        this.dataListCode = response.data.data;
      } catch (error) {
        console.error("Error fetching code list:", error);
      }
    },

    async assignCodeToBranch() {
      if (this.code_id === 0) {
        this.showErrorMessage("Please select code");
        return;
      }

      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const dataForm = {
          merchantId,
          branch_id: this.idToUpdateBranch,
          code_id: this.code_id,
        };

        await MerchantService.assignCodeToBranch(dataForm);
        await this.getListCodeByBranch();
        $(".btn-close-code-assign-to-branch").click();
        this.code_id = 0;
        this.showSuccessMessage("Save successfully!");
      } catch (error) {
        console.error("Error assigning code:", error);
        this.showErrorMessage("Code existing!");
      } finally {
        this.hideLoader();
      }
    },

    async getListCodeByBranch(isWithoutBranch = false) {
      const merchantId = this.$route.params.id;
      const dataForm = { merchantId };

      if (!isWithoutBranch) {
        dataForm.branch_id = this.idToUpdateBranch;
        dataForm.search_keyword = this.textSearchListCodeByBranch;
      }

      try {
        const response = await MerchantService.listCodeByBranch(dataForm);
        this.dataListCodeByBranch = response.data.data;
      } catch (error) {
        console.error("Error fetching code by branch:", error);
      }
    },

    confirmDeleteCodeAssigned(id) {
      this.idToDeleteCodeAssignedToBranch = id;
    },

    async deleteCodeAssigned() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        await MerchantService.deleteCodeAssignedToBranch({
          merchantId,
          id: this.idToDeleteCodeAssignedToBranch,
        });

        await this.getListCodeByBranch();
        this.idToDeleteCodeAssignedToBranch = 0;
        this.showSuccessMessage("Delete successfully!");
      } catch (error) {
        console.error("Error deleting code:", error);
        this.showErrorMessage(error.message || "Failed to delete");
      } finally {
        this.hideLoader();
      }
    },

    showBoxStripeReaders(code) {
      this.showDivBoxStripeReaders = code.id;
      this.minty_assign_code_to_branch_id = code.minty_assign_code_to_branch_id;
      this.listReader();
    },

    async saveConnectedAccount(code) {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        await MerchantService.updateCode({
          merchantId,
          id: code.minty_assign_code_to_branch_id,
          connected_account: this.connected_account,
        });

        this.showSuccessMessage("Save successfully!");
        await this.getListCodeByBranch(true);
      } catch (error) {
        console.error("Error saving connected account:", error);
        this.showErrorMessage(error.message || "Failed to save");
      } finally {
        this.hideLoader();
      }
    },

    async createReader() {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const dataForm = {
          merchantId,
          id: this.reader_id || 0,
          number: this.reader_number_id,
          code: this.reader_code,
          statement: this.reader_statement,
          code_id: this.minty_assign_code_to_branch_id,
        };

        const response = await MerchantService.createReader(dataForm);

        if (response.data.result.isSuccess === false) {
          this.showErrorMessage(response.data.result.message);
        } else {
          await this.listReader();
          $(".btn-close-modal-create-reader").click();
          this.showSuccessMessage("Save successfully!");
        }
        this.resetCreateReader("add");
      } catch (error) {
        console.error("Error creating reader:", error);
        this.showErrorMessage(error.message || "Failed to save");
      } finally {
        this.hideLoader();
      }
    },

    async listReader() {
      const merchantId = this.$route.params.id;

      try {
        const response = await MerchantService.listReaderByCode({
          merchantId,
          minty_assign_code_to_branch_id: this.minty_assign_code_to_branch_id,
        });
        this.dataListReaderByCode = response.data.data;
      } catch (error) {
        console.error("Error fetching readers:", error);
      }
    },

    showPopupEditReader(reader) {
      this.reader_id = reader.id;
      this.reader_number_id = reader.number;
      this.reader_code = reader.code;
      this.reader_statement = reader.statement;
      $(".btn-update-reader").click();
    },

    resetCreateReader(type) {
      if (type === "add") {
        this.reader_id = "";
        this.reader_number_id = "";
        this.reader_code = "";
        this.reader_statement = "";
      }
    },

    async getParentCompany() {
      try {
        const response = await MerchantService.getAllMerchant();
        this.dataListAllMerchant = response.data.data;
      } catch (error) {
        console.error("Error fetching parent companies:", error);
      }
    },

    async createMerchantUserAccount() {
      this.formUser.merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const response = await MerchantService.createMerchantUserAccount(
          this.formUser
        );

        if (response.data.result.isSuccess === false) {
          this.showErrorMessage(response.data.result.message);
        } else {
          await this.changeTab(5);
          this.showSuccessMessage("Save successfully!");
          $(".btn-close-modal-create-merchant-account").click();
          this.resetCreateMerchantUserAccount();
        }
      } catch (error) {
        console.error("Error creating user account:", error);
        this.showErrorMessage(
          error.response?.data?.result?.message || "Failed to save"
        );
      } finally {
        this.hideLoader();
      }
    },

    resetCreateMerchantUserAccount() {
      this.formUser = { ...INITIAL_USER_STATE };
    },

    editMerchantUserAccount(user) {
      this.formUser = {
        id: user.id,
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        phone_number: user.phone_number,
        password: user.password,
        last_login_at_formated: user.last_login_at_formated,
        status: user.status,
        showPassword: false,
        merchantId: this.$route.params.id,
      };
    },

    async updateStatusUserAccount() {
      this.showLoader();

      try {
        const response = await MerchantService.updateStatusUserAccount(
          this.formUser
        );

        if (response.data.result.isSuccess === false) {
          this.showErrorMessage(response.data.result.message);
        } else {
          await this.changeTab(5);
          this.showSuccessMessage("Save successfully!");
          $(".btn-close-modal-create-merchant-account").click();
          this.resetCreateMerchantUserAccount();
        }
      } catch (error) {
        console.error("Error updating status:", error);
        this.showErrorMessage(
          error.response?.data?.result?.message || "Failed to update"
        );
      } finally {
        this.hideLoader();
      }
    },

    async resetPasswordUserAccount(id) {
      const merchantId = this.$route.params.id;
      this.showLoader();

      try {
        const response = await MerchantService.resetPasswordUserAccount({
          id,
          merchantId,
        });

        if (response.data.result.isSuccess === false) {
          this.showErrorMessage(response.data.result.message);
        } else {
          await this.changeTab(5);
          this.showSuccessMessage("Sent successfully!");
          $(".btn-close-modal-create-merchant-account").click();
          this.resetCreateMerchantUserAccount();
        }
      } catch (error) {
        console.error("Error resetting password:", error);
        this.showErrorMessage(
          error.response?.data?.result?.message || "Failed to reset password"
        );
      } finally {
        this.hideLoader();
      }
    },

    downloadLoginUsers() {
      $("#downloadFormLoginUsers").click();
    },
  },
};
</script>

<style scoped>
#preview img {
  min-width: 150px;
  min-height: 150px;
  max-width: 150px;
  max-height: 150px;
  object-fit: cover;
}

.required {
  color: red;
}

.physical-branch-form .form-label {
  min-width: 190px;
}

.branch-edit-container,
.stripe-reader-container {
  width: 100%;
  border: 1px solid gainsboro;
  border-radius: 5px;
  padding: 20px;
}

.i-password {
  position: relative;
}

.i-password i {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  z-index: 99999;
}
</style>